import Image from 'next/image'
import Link from 'next/link'

export const NextLink = Link
export const NextImage = Image
